import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconInfographicStyle0 = cosmosIconCss;

const CosmosIconInfographic$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfographic extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b90c929adbb7a8f6412ceceb5b67901cd8b85bd9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ff09678b89cab9cc54e8e3e6db002e55f6993347', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '94d36ad28a377a1a9bf597fecd5227d374ba3be0', d: "M12 2a8 8 0 0 1 8 8h-7.5a.5.5 0 0 1-.5-.5V2Z", fill: "currentColor" }), h("path", { key: '925cb64bdf25fd274edbc343152a2288865cfd63', d: "M10 20a8 8 0 0 0 8-8h-7.5a.5.5 0 0 1-.5-.5V4a8 8 0 1 0 0 16Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconInfographicStyle0; }
}, [1, "cosmos-icon-infographic", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-infographic"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-infographic":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfographic$1);
            }
            break;
    } });
}

const CosmosIconInfographic = CosmosIconInfographic$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfographic, defineCustomElement };
